import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PostData } from '../models/post.model';


@Component({
  selector: 'app-edit-post-dialog',
  template: `
    <h1 mat-dialog-title>Modifier la publication</h1>
    <div mat-dialog-content>
      <img [src]="data.imageUrl" alt="Post Image" style="width: 100%; height: auto;">
      <mat-form-field appearance="fill" style="width: 100%; margin-top: 15px;">
        <mat-label>Texte de la publication</mat-label>
        <textarea matInput [(ngModel)]="data.comment"></textarea>
      </mat-form-field>
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onCancel()">Annuler</button>
      <button mat-button color="primary" (click)="onSave()">Valider</button>
    </div>
  `
})
export class EditPostDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<EditPostDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PostData
  ) {}

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.dialogRef.close({ updatedText: this.data.comment });
  }
}
